import { useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../../shared/i18n/useLang";
import AuthShell, { TextField } from "../components/AuthShell";
import { solicitarReset } from "../services/accesoService";

/**
 * /recuperar — pide el link para elegir una contraseña nueva.
 *
 * Acepta usuario o correo. La respuesta es la misma exista o no la cuenta,
 * para que este formulario no sirva para averiguar quién está registrado.
 */
export default function RecuperarPage() {
  const L = useLang();
  const [ident, setIdent] = useState("");
  const [error, setError] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState("");

  async function enviar(ev) {
    ev.preventDefault();
    setError("");
    if (!ident.trim()) {
      setError(L("Ingresá tu usuario o tu correo.", "Enter your username or email."));
      return;
    }
    setEnviando(true);
    try {
      const r = await solicitarReset(ident.trim());
      setEnviado(r.detail || L("Te enviamos un enlace al correo registrado.", "We sent a link to your registered email."));
    } catch (e) {
      setError(e.message);
    } finally {
      setEnviando(false);
    }
  }

  return (
    <AuthShell>
      <h2 className="lp-form-title">{L("Recuperar contraseña", "Reset password")}</h2>
      <p className="lp-form-sub">
        {L("Escribí tu usuario o el correo de tu cuenta y te mandamos un enlace para elegir una contraseña nueva.",
           "Enter your username or account email and we'll send you a link to choose a new password.")}
      </p>

      {enviado ? (
        <>
          <div className="lp-ok">
            <i className="fa-solid fa-envelope-circle-check" style={{ marginTop: 2 }} />
            <span>
              {enviado}{" "}
              {L("Revisá también la carpeta de spam.", "Also check your spam folder.")}
            </span>
          </div>
          <Link to="/login" className="lp-btn" style={{ textDecoration: "none", display: "flex", justifyContent: "center" }}>
            {L("Volver a iniciar sesión", "Back to sign in")}
          </Link>
        </>
      ) : (
        <form onSubmit={enviar} noValidate>
          {error && (
            <div className="lp-api-err">
              <i className="fa-solid fa-circle-exclamation" />
              {error}
            </div>
          )}
          <TextField id="rec-ident" label={L("Usuario o correo", "Username or email")} value={ident}
            onChange={(v) => { setIdent(v); setError(""); }} disabled={enviando}
            icon="fa-user" autoComplete="username" autoFocus />
          <button type="submit" className="lp-btn" disabled={enviando}>
            {enviando
              ? <><i className="fa-solid fa-circle-notch lp-spin" /> {L("Enviando…", "Sending…")}</>
              : L("Enviar enlace", "Send link")}
          </button>
          <div style={{ textAlign: "center", marginTop: 14 }}>
            <Link to="/login" className="lp-link">
              <i className="fa-solid fa-arrow-left" style={{ marginRight: 6 }} />
              {L("Volver a iniciar sesión", "Back to sign in")}
            </Link>
          </div>
        </form>
      )}
    </AuthShell>
  );
}
